export default {
  categories: [],
  categoryInfos: {
    id: null,
    name: null,
    slug: null,
    activated: null,
    image_url: null,
    description: null,
  },
  totalPages: 1
}
